import Tooltip from "./Tooltip";

const ToggleSwitch = ({ checked, onChange, disabled = false, title = "" }) => {
  return (
    <Tooltip title={title}>
      <div className="form-check form-switch m-0">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          style={{
            width: "3rem",
            height: "1.5rem",
            cursor: disabled ? "not-allowed" : "pointer",
            ...(checked && {
              backgroundColor: "#f0b342",
              borderColor: "#f0b342",
            }),
          }}
        />
      </div>
    </Tooltip>
  );
};

export default ToggleSwitch;
